<template>
  <div>
    <h2 class="title is-4">Gestión de Atributos</h2>
    <div v-for="(attribute, index) in attributes" :key="index" class="box">
      <div class="field is-grouped is-grouped-multiline">
        <div class="control">
          <input
            v-model="attribute.name"
            class="input"
            type="text"
            placeholder="Nombre del Atributo"
          />
        </div>
        <div class="control">
          <div class="select">
            <select v-model="attribute.type">
              <option value="text">Texto</option>
              <option value="number">Número</option>
              <option value="select">Selección</option>
            </select>
          </div>
        </div>
        <div class="control" v-if="attribute.type === 'select'">
          <input
            v-model="attribute.values"
            class="input"
            type="text"
            placeholder="Valores (separados por comas)"
          />
        </div>
        <div class="control">
          <button
            @click="remove_attribute(index)"
            class="button is-danger is-light"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button @click="add_attribute" class="button is-primary">
          Agregar Atributo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attributes: [{ name: "", type: "text", values: "" }],
    };
  },
  methods: {
    add_attribute() {
      this.attributes.push({ name: "", type: "text", values: "" });
    },
    remove_attribute(index) {
      this.attributes.splice(index, 1);
    },
    get_attributes() {
      return this.attributes;
    },
    set_initial_state() {
      this.attributes = [];
    },
    set_attributes(attributes) {
      this.attributes = attributes;
    },
  },
};
</script>

<style scoped>
.field {
  margin-bottom: 10px;
}
</style>
